<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :error="isError"
                           :withEmplyFields="true"
                           :title="titreMessage"
                           @close="isError = $event"/>
      <section class="has-text-centered">
        <b-icon
          type="is-warning"
          icon="alert-outline"
          class="icon-modal">
        </b-icon>
        <p class="modal-title has-text-centered " v-if="this.devisCommandes.length > 1">
          {{ $t(refI18n + '.deleteMultiple')}}
        </p>
        <p class="modal-title has-text-centered" v-else>
          {{ $t(refI18n + '.delete')}}
        </p>
      </section>
      <br>
      <footer>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
                  @click="$parent.close()">
            {{ $t(refI18n + '.no')}}
          </button>
          <button class="button is-warning has-text-centered button-modal"
                  @click="supprimer()">
            {{ $t(refI18n + '.yes')}}
          </button>
        </div>
      </footer>
      <footer>
        <p class="subtitle is-5 modal-complement has-text-centered"
          v-if="this.devisCommandes.length > 1">
          {{ $t(refI18n + '.irreversibleMultiple')}}
        </p>
        <p class="subtitle is-5 modal-complement has-text-centered" v-else>
          {{ $t(refI18n + '.irreversible')}}
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/devisCommandes/validation/validationSuppression';
import * as devisConf from '@/configuration/devisConf';
import { remove as removeCommande } from '@/api/commande/index';
import { remove as removeFacture } from '@/api/facture/index';
import { remove as removeDevis } from '@/api/devis/index';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  name: 'confirmation-suppression-commande',
  props: ['devisCommandes', 'type'],
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      titreMessage: '',
      isError: false,
    };
  },
  computed: {
    refI18n() {
      if (this.type === devisConf.TYPE_COMMANDE) {
        return 'supprimerCommande';
      }
      if (this.type === devisConf.TYPE_DEVIS) {
        return 'supprimerDevis';
      }
      if (this.type === devisConf.TYPE_FACTURE) {
        return 'supprimerFacture';
      }
      return '';
    },
  },
  methods: {
    async supprimer() {
      if (this.devisCommandes.length === 0) {
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.titreMessage = this.refI18n + '.messages.errorTitle';
        switch (this.type) {
          case devisConf.TYPE_DEVIS:
            await removeDevis(this.devisCommandes[0].id);
            break;
          case devisConf.TYPE_COMMANDE:
            await removeCommande(this.devisCommandes[0].id);
            break;
          case devisConf.TYPE_FACTURE:
            await removeFacture(this.devisCommandes[0].id);
            break;
          default:
            throw new Error('suppression type DCF mauvais');
        }
        messageSucces(this.$i18n.t(this.refI18n + '.messages.success'));
        this.$emit('rechargement');
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messages, this.refI18n);
          this.isError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>
